// import React from "react";
// import "./about_us_content.css";

// const AboutUsContent = () => {
//   return (
//     <div className="about-us-container">
//       <h2 className="about-us-title">About Us</h2>

//       <p className="about-us-description">
//         After years in corporate leadership, our founder stepped away from the
//         boardroom to build something with purpose. That leap gave birth to
//         WikiWorks a tech company focused on fairness, not just functions. We saw
//         how contract workers often uneducated and unheard were left vulnerable.
//         It was time for a change.  
//       </p>
//       <p className="about-us-description">
//         When we uncovered the core issue, something powerful became clear: many
//         major brands wanted to support their workforce and offer real safety and
//         assurance but didn’t know how. That gap between intention and action?
//         That was the opportunity. And it gave rise to VYN. 
//       </p>
//       <p className="about-us-description">
//         VYN bridges that gap—helping companies do right by their people with
//         tools that protect, empower, and build trust. With partners like UKG,
//         our mission is bold: secure 50% of the global contract workforce and
//         make dignity at work the new standard.
//       </p>
//     </div>
//   );
// };

// export default AboutUsContent;

import React, { useRef, useEffect, useState } from "react";
import { useSpring, animated } from 'react-spring'; // Correct import
import "./about_us_content.css";

const AboutUsContent = () => {
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);

  // Intersection Observer to detect when the section is in view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting); // Update inView based on visibility
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px'
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  // Animation for the title
  const titleAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(20px)',
    config: {
      tension: 180,
      friction: 35,
      mass: 1
    },
    delay: inView ? 300 : 0
  });

  // Animation for the first paragraph
  const paragraph1Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(15px)',
    config: {
      tension: 160,
      friction: 30,
      mass: 1
    },
    delay: inView ? 450 : 0
  });

  // Animation for the second paragraph
  const paragraph2Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(15px)',
    config: {
      tension: 160,
      friction: 30,
      mass: 1
    },
    delay: inView ? 600 : 0
  });

  // Animation for the third paragraph
  const paragraph3Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(15px)',
    config: {
      tension: 160,
      friction: 30,
      mass: 1
    },
    delay: inView ? 750 : 0
  });

  return (
    <div className={`about-us-container ${inView ? 'animate-background' : ''}`} ref={containerRef}>
      <animated.h2 className="about-us-title" style={titleAnimation}>
        About Us
      </animated.h2>

      <animated.p className="about-us-description" style={paragraph1Animation}>
        After years in corporate leadership, our founder stepped away from the
        boardroom to build something with purpose. That leap gave birth to
        WikiWorks a tech company focused on fairness, not just functions. We saw
        how contract workers often uneducated and unheard were left vulnerable.
        It was time for a change. 
      </animated.p>
      <animated.p className="about-us-description" style={paragraph2Animation}>
        When we uncovered the core issue, something powerful became clear: many
        major brands wanted to support their workforce and offer real safety and
        assurance but didn’t know how. That gap between intention and action?
        That was the opportunity. And it gave rise to VYN. 
      </animated.p>
      <animated.p className="about-us-description" style={paragraph3Animation}>
        VYN bridges that gap—helping companies do right by their people with
        tools that protect, empower, and build trust. With partners like UKG,
        our mission is bold: secure 50% of the global contract workforce and
        make dignity at work the new standard.
      </animated.p>
    </div>
  );
};

export default AboutUsContent;